import { inject, Injectable } from "@angular/core";
import { MCUniqueItemLogics, MCItemDetailsValidator } from "@maslul/common-services";
import { ProductsStoreService } from "../store/products";

@Injectable({
    providedIn: 'root'
})
export class ProductValidation extends MCItemDetailsValidator {

    productsStore = inject(ProductsStoreService);

    override getOtherItemsRows(fieldsNames: string[]): any[] {
        const activeProductGuid = this.productsStore.getSnapshot().activeProduct || "";
        const allProducts = this.productsStore.getSnapshot().products;

        if (!allProducts) return [];

        const otherRows: any[] = [];
        allProducts.forEach((product, guid) => {
            if (guid === activeProductGuid) return;
            const model = product.formisFormModel;
            if (model) {
                const rows = MCUniqueItemLogics.extractValidationRowsFromObject(model, fieldsNames);
                otherRows.push(...rows);
            }
        });

        return otherRows;
    }
}
